import React from 'react';
import Chip from '../../shared/Chip';
import './Step3PreviewQA.css';

/**
 * View Component for Step 3: Preview & QA Gate
 */
const Step3PreviewQA = ({
  refinementNotes,
  onRefinementNotesChange,
  connectionData,
}) => {
  const getConnectionTypeLabel = (type) => {
    if (type === 'azure_blob') return 'Azure Blob';
    if (type === 'aws_s3') return 'AWS S3';
    if (type === 'gcs') return 'Google Cloud Storage';
    return type;
  };

  return (
    <div className="step3-preview-container">
      <h3 className="step3-preview-title">Review and Publish</h3>
      <p className="step3-preview-subtitle">Review your dataset configuration and publish to start indexing.</p>

      {connectionData && connectionData.selectedSource === 'connection' && (
        <div className="step3-connection-details">
          <h4 className="step3-connection-title">Connection configured</h4>
          <div className="step3-connection-info">
            <div className="step3-connection-item">
              <span className="step3-connection-label">Type:</span>
              <Chip className="step3-connection-type-badge">
                {getConnectionTypeLabel(connectionData.connectionType)}
              </Chip>
            </div>
            <div className="step3-connection-item">
              <span className="step3-connection-label">Account:</span>
              <span className="step3-connection-value">{connectionData.storageAccount || 'N/A'}</span>
            </div>
            <div className="step3-connection-item">
              <span className="step3-connection-label">Container:</span>
              <span className="step3-connection-value">{connectionData.containerName || 'N/A'}</span>
            </div>
            <div className="step3-connection-item">
              <span className="step3-connection-label">Path/Prefix:</span>
              <span className="step3-connection-value">{connectionData.pathPrefix || 'N/A'}</span>
            </div>
            <div className="step3-connection-status">
              <Chip variant="success" className="step3-ready-badge">Ready</Chip>
            </div>
          </div>
        </div>
      )}

      {connectionData && connectionData.selectedSource === 'local' && (
        <div className="step3-connection-details">
          <h4 className="step3-connection-title">Files configured</h4>
          <div className="step3-connection-status">
            <Chip variant="success" className="step3-ready-badge">Ready</Chip>
          </div>
        </div>
      )}

      <div className="step3-discovery-section">
        <h4 className="step3-discovery-title">Discovery happens after publish</h4>
        <p className="step3-discovery-text">
          File listing + metadata will be captured during the first ingestion run after publishing. After the first run, you'll see row/field counts and previews in Data Sources.
        </p>
      </div>
    </div>
  );
};

export default Step3PreviewQA;
